export default __webpack_public_path__ + "static/media/AdobeStock_74500319.2b7a935d.jpeg";